module.exports = __webpack_public_path__ + "img/BlocodeLogoWhite.846f0925.png";